<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="item-select">
        <label>项目组：</label>
        <el-select size="mini" v-model="teamId" placeholder="请选择">
          <el-option v-for="item in teamArr" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <el-input style="margin-top:5px;" v-model="filterKey" size="mini" placeholder="项目编号/项目名/负责人"></el-input>
    </div>

    <div class="ball-loading" v-if="loading">
      <div class="k-ball-holder3">
        <div class="k-ball7a"></div>
        <div class="k-ball7b"></div>
        <div class="k-ball7c"></div>
        <div class="k-ball7d"></div>
      </div>
    </div>
    <div class="card-room" v-else>
      <div class="no-list" v-if="paginationData.length<1">
        <p>暂无与你相关的工程项目</p>
      </div>
      <div class="card-item" v-else v-for="item, i in paginationData">
        <div class="title">
          <div class="r">编号：{{item.number}}</div>
          <h3 class="name">{{item.name}}</h3>
        </div>
        <div class="info">
          <p class="r">{{item.team?item.team.name:''}}</p>
          <p class="status">当前进度：{{item.status}}</p>
          <p>{{item.deptName}}</p>
          <p>项目负责人：{{ item.leader.name+" - "+(item.leader.telephone?item.leader.telephone:item.leader.mobile) }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  export default {
    components: {},
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 列表
        loading: true,
        pageSize: 2000,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        teamId: 0,
        filterKey: "",
        teamArr: [],
      }
    },
    mounted() {
      this.getLists()
      // 获取项目组
      this.getTeam()
    },
    methods: {
      // 获取项目组
      getTeam() {
        ajax.post('/gc/project/team/list', '', (res) => {
          this.teamArr = [{
            id: 0,
            name: "全部"
          }]
          this.teamArr = this.teamArr.concat(res.vo.array)
        })
      },
      startCreate() {
        this.$router.push("/Project/Create")
      },
      projectDetail(row) {
        this.$router.push("/Project/Detail/" + row.id)
      },
      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.teamId || this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _project = this.listData[i]
            let _filterStatus = true
            if (this.teamId && _project.team.id != this.teamId) {
              _filterStatus = false
            }
            if (_filterStatus) {
              if (_project.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _project.leader.name.toLowerCase()
                .indexOf(this.filterKey.toLowerCase()) != -1 ||
                _project.number.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
                this.filterData.push(_project)
              }
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/user/project/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'teamId'() {
        this.getFilterData()
      },
      'filterKey'() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/m/projectlist.vue